module.exports = __webpack_public_path__ + "static/media/sipgate_dachmarke_15_no_support.78b211d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sipgate_dachmarke_15_no_support.png
// module id = 927
// module chunks = 0